import Button from "@mui/material/Button";
import Testo from "../elementi/Testo";
import { monFetch } from "../inc/inc";
import { useParams } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";

import DeleteIcon from "@mui/icons-material/Delete";
import AutocompleteMon from "../elementi/AutocompleteMon";

import Tooltip from "@mui/material/Tooltip";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

import InsertLinkIcon from "@mui/icons-material/InsertLink";

const Comp = (props) => {
  let params = useParams();

  let id = params.id;

  const [testo, setTesto] = useState("");
  const [noteInterne, setNoteInterne] = useState("");
  const [noteCommerciale, setNoteCommerciale] = useState("");
  const [sezione, setSezione] = useState(null);
  const [sottosezione, setSottosezione] = useState(null);

  const [sezionePadre, setSezionePadre] = useState(null);
  const [sottosezionePadre, setSottosezionePadre] = useState(null);
  const [domandaPadre, setDomandaPadre] = useState(null);
  const [rispostaPadre, setRispostaPadre] = useState(null);

  const [optionsSottosezioniDomanda, setOptionsSottosezioniDomanda] = useState(
    []
  );

  const [optionsSezioni, setOptionsSezioni] = useState([]);
  const [optionsSottosezioni, setOptionsSottosezioni] = useState([]);
  const [optionsDomande, setOptionsDomande] = useState([]);
  const [optionsRisposte, setOptionsRisposte] = useState([]);

  const [maxRisposte, setMaxRisposte] = useState(1);
  const [optionsMaxRisposte, setOptionsMaxRisposte] = useState([
    {
      label: "1",
      value: "1",
    },
    {
      label: "2",
      value: "2",
    },
    {
      label: "3",
      value: "3",
    },
    {
      label: "4",
      value: "4",
    },
    {
      label: "5",
      value: "5",
    },
  ]);

  const [risposte, setRisposte] = useState([]);


  async function queryDomanda(id) {
    const res = await monFetch("/questionGet", {
      id: id,
    });
    const domanda = res.question;
    setTesto(domanda.text);
    setNoteInterne(domanda.internal_note);
    setNoteCommerciale(domanda.commercial_note);

    setSottosezione(domanda.subsection_id);
    setMaxRisposte(domanda.max_answers)

    if (domanda.section_id) {
      setSezione(domanda.section_id);
      querySottosezione(domanda.section_id);
    }

    if (domanda.sectionParentId) {
      setSezionePadre(domanda.sectionParentId);
      querySottosezionePadre(domanda.sectionParentId);
    }

    if (domanda.subsectionParentId) {
      setSottosezionePadre(domanda.subsectionParentId);
      queryDomandePadre(domanda.subsectionParentId);
    }
    if (domanda.questionParentId) {
      setDomandaPadre(domanda.questionParentId);
      queryRispostePadre(domanda.questionParentId);
    }
    setRispostaPadre(domanda.parent_answer_id);

    let temp = [];

    domanda.answers.forEach((el) => {
      temp.push({
        textParent: el.textParent,
        idParent: el.idParent,
        isParent: el.isParent,
        id: el.id,
        testo: el.text,
        punteggio: el.score,
        noteCommerciale: el.commercial_note,
        noteInterne: el.internal_note,

      });
    });

    setRisposte(temp);
  }

  async function querySezioni() {
    const res = await monFetch("/sectionList", {});
    const temp = [];
    res.section.forEach((el) => {
      temp.push({
        label: el.name,
        value: el.id,
      });
    });
    setOptionsSezioni(temp);
  }

  async function querySottosezionePadre(sezione) {
    const res = await monFetch("/subsectionList", {
      section_id: sezione,
    });
    const temp = [];
    res.subsection.forEach((el) => {
      temp.push({
        label: el.name,
        value: el.id,
      });
    });
    setOptionsSottosezioni(temp);
  }

  async function querySottosezione(sezione) {
    const res = await monFetch("/subsectionList", {
      section_id: sezione,
    });
    const temp = [];
    res.subsection.forEach((el) => {
      temp.push({
        label: el.name,
        value: el.id,
      });
    });
    setOptionsSottosezioniDomanda(temp);
  }

  async function queryDomandePadre(sezione) {
    console.log(sezione);
    const res = await monFetch("/questionList", {
      subsection_id: sezione,
    });
    const temp = [];
    res.questionList.forEach((el) => {
      temp.push({
        label: el.textNoHtml,
        value: el.id,
      });
    });
    setOptionsDomande(temp);
  }

  async function queryRispostePadre(domanda) {
    const res = await monFetch("/answerList", {
      question_id: domanda,
    });
    // console.log(res);
    const temp = [];
    res.answer.forEach((el) => {
      temp.push({
        label: el.text,
        value: el.id,
      });
    });
    setOptionsRisposte(temp);
  }

  async function salvaDomanda(e) {
    e.preventDefault();

    // console.log(risposte);
    // return
    const res = await monFetch("/questionSet", {
      id: id,
      text: testo,
      commercial_note: noteCommerciale,
      internal_note: noteInterne,
      subsection_id: sottosezione,
      answers: risposte,
      parent_answer_id: rispostaPadre,
      max_answers: maxRisposte
    });

    if (res.success) {
      if (res.id) {
        window.location.href =
          process.env.PUBLIC_URL + "/domande?idDom=" + res.id;
      } else {
        window.location.href = process.env.PUBLIC_URL + "/domande?idDom=" + id;
      }
    }
  }

  async function settaDatiRisposta(dati) {
    let temp = [...dati.elem];
    temp[dati.index][dati.campo] = dati.valore;

    setRisposte(temp);
  }

  useEffect(() => {
    props.setTestoTitolo(props.nuovo ? "Aggiungi Domanda" : "Modifica Domanda");
    if (id) {
      queryDomanda(id);
    }
    querySezioni();
  }, []);

  return (
    <form onSubmit={(e) => salvaDomanda(e)}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <div className="bgColor boxColor">
            <Grid container spacing={2}>
              <Grid item sm={12} xs={12}>
                <h4>
                  Seleziona risposta padre{" "}
                  <small style={{ marginLeft: 5 }}>
                    Filtra per sezione e domanda per selezionare la risposta
                    padre
                  </small>
                </h4>
              </Grid>
              <Grid item sm={3} xs={12}>
                <AutocompleteMon
                  value={
                    optionsSezioni.find((op) => op.value == sezionePadre) ||
                    null
                  }
                  onChange={(e, value) => {
                    if (!value) {
                      setSezionePadre(null);
                      return;
                    }
                    setSezionePadre(value.value);
                    querySottosezionePadre(value.value);
                  }}
                  options={optionsSezioni}
                  label="Sezione"
                />
              </Grid>

              {sezionePadre !== null && (
                <Grid item sm={3} xs={12}>
                  <AutocompleteMon
                    value={
                      optionsSottosezioni.find(
                        (op) => op.value == sottosezionePadre
                      ) || null
                    }
                    onChange={(e, value) => {
                      console.log(value);
                      if (!value) {
                        setSottosezionePadre(null);
                        return;
                      }
                      setSottosezionePadre(value.value);
                      queryDomandePadre(value.value);
                    }}
                    options={optionsSottosezioni}
                    label="Sottosezione"
                  />
                </Grid>
              )}

              {sottosezionePadre !== null && (
                <Grid item sm={3} xs={12}>
                  <AutocompleteMon
                    value={
                      optionsDomande.find((op) => op.value == domandaPadre) ||
                      null
                    }
                    onChange={(e, value) => {
                      if (!value) {
                        setDomandaPadre(null);
                        return;
                      }
                      setDomandaPadre(value.value);
                      queryRispostePadre(value.value);
                    }}
                    options={optionsDomande}
                    label="Domanda"
                  />
                </Grid>
              )}

              {domandaPadre !== null && (
                <Grid item sm={2} xs={12}>
                  <AutocompleteMon
                    value={
                      optionsRisposte.find((op) => op.value == rispostaPadre) ||
                      null
                    }
                    onChange={(e, value) => {
                      if (!value) {
                        setRispostaPadre(null);
                        return;
                      }
                      setRispostaPadre(value.value);
                    }}
                    options={optionsRisposte}
                    label="Risposta"
                  />
                </Grid>
              )}
              {rispostaPadre && (
                <Grid
                  item
                  sm={1}
                  xs={12}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <a href={process.env.PUBLIC_URL + "/domanda/" + domandaPadre}>
                    <InsertLinkIcon />
                  </a>
                </Grid>
              )}
            </Grid>
          </div>
        </Grid>
        <Grid item xs={12}>
          <div className="bgColor2 boxColor">
            <h4>Domanda</h4>
            <Grid container spacing={2}>
              <Grid item sm={4} xs={12}>
                <AutocompleteMon
                  value={
                    optionsSezioni.find((op) => op.value == sezione) || null
                  }
                  onChange={(e, value) => {
                    if (!value) {
                      setSezione(null);
                      return;
                    }
                    setSezione(value.value);
                    querySottosezione(value.value);
                  }}
                  options={optionsSezioni}
                  label="Sezione"
                  inputRequired={true}
                />
              </Grid>

              <Grid item sm={6} xs={12}>
                <AutocompleteMon
                  value={
                    optionsSottosezioniDomanda.find(
                      (op) => op.value == sottosezione
                    ) || null
                  }
                  onChange={(e, value) => {
                    if (!value) {
                      setSottosezione(null);
                      return;
                    }
                    setSottosezione(value.value);
                  }}
                  options={optionsSottosezioniDomanda}
                  label="Sottosezione"
                  inputRequired={true}
                />
              </Grid>
              <Grid item sm={2} xs={12}>
                <AutocompleteMon
                  value={
                    optionsMaxRisposte.find(
                      (op) => op.value == maxRisposte
                    ) || null
                  }
                  onChange={(e, value) => {
                    if (!value) {
                      setMaxRisposte(1);
                      return;
                    }
                    setMaxRisposte(value.value);
                  }}
                  options={optionsMaxRisposte}
                  label="Max risposte"
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <h4>Testo Domanda</h4>
                <CKEditor
                  config={{
                    placeholder: "Testo domanda...",
                    toolbar: ["bold", "italic", "|", "undo", "redo"],
                  }}
                  editor={ClassicEditor}
                  data={testo}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setTesto(data);
                  }}
                />
                {/* <Testo
                  multiline
                  rows={4}
                  required
                  label="Testo domanda"
                  value={testo}
                  onChange={(e) => {
                    setTesto(e.target.value);
                  }}
                /> */}
              </Grid>
              <Grid item sm={3} xs={12}>
                <h4>Spiegazioni domanda</h4>
                <CKEditor
                  config={{
                    placeholder: "Note Interne...",
                    toolbar: ["bold", "italic", "|", "undo", "redo"],
                  }}
                  editor={ClassicEditor}
                  data={noteInterne || ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setNoteInterne(data);
                  }}
                />
                {/* <Testo
                  multiline
                  rows={4}
                  label="Note Interne"
                  value={noteInterne}
                  onChange={(e) => {
                    setNoteInterne(e.target.value);
                  }}
                /> */}
              </Grid>
              <Grid item sm={3} xs={12}>
                <h4>Note Commerciale domanda</h4>
                <CKEditor
                  config={{
                    placeholder: "Note Commerciale...",
                    toolbar: ["bold", "italic", "|", "undo", "redo"],
                  }}
                  editor={ClassicEditor}
                  data={noteCommerciale || ""}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setNoteCommerciale(data);
                  }}
                />
                {/* <Testo
                  multiline
                  rows={4}
                  label="Note Commerciale"
                  value={noteCommerciale}
                  onChange={(e) => {
                    setNoteCommerciale(e.target.value);
                  }}
                /> */}
              </Grid>
            </Grid>
          </div>
        </Grid>

        {/* risposte -------------------- */}
        <Grid item sm={12} xs={12}>
          {/* <div> */}
          <h3 style={{ marginTop: 0, marginBottom: 0 }}>Risposte</h3>

          {/* </div> */}
          <Table style={{ marginTop: 0 }} className="tableAlignTop">
            <TableHead>
              <TableRow>
                <TableCell style={{ width: 550 }}>Testo risposta</TableCell>
                <TableCell style={{ width: 100 }}>Punteggio</TableCell>
                <TableCell>Note Commerciale risposta</TableCell>
                <TableCell>Risposta Interna</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {risposte.map((el, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell>
                      <Testo
                        multiline
                        rows={4}
                        label="Testo risposta"
                        value={el.testo || ""}
                        onChange={(e) => {
                          settaDatiRisposta({
                            elem: risposte,
                            index: index,
                            campo: "testo",
                            valore: e.target.value,
                          });
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Testo
                        type="number"
                        label="Punteggio"
                        value={el.punteggio || 0}
                        onChange={(e) => {
                          settaDatiRisposta({
                            elem: risposte,
                            index: index,
                            campo: "punteggio",
                            valore: e.target.value,
                          });
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Testo
                        multiline
                        rows={4}
                        label="Note Commerciale risposta"
                        value={el.noteCommerciale || ""}
                        onChange={(e) => {
                          settaDatiRisposta({
                            elem: risposte,
                            index: index,
                            campo: "noteCommerciale",
                            valore: e.target.value,
                          });
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Testo
                        multiline
                        rows={4}
                        label="Risposta Interna"
                        value={el.noteInterne || ""}
                        onChange={(e) => {
                          settaDatiRisposta({
                            elem: risposte,
                            index: index,
                            campo: "noteInterne",
                            valore: e.target.value,
                          });
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      {el.isParent ? (
                        //disabilito se la risposta è parent di una domanda
                        <Tooltip
                          title={
                            <>
                              Impossibile eliminare.
                              <br />
                              La risposta è padre della seguente domanda:
                              <br /> {el.textParent}
                              <br />
                              <a
                                href={
                                  process.env.PUBLIC_URL +
                                  "/domanda/" +
                                  el.idParent
                                }
                                className="linkButton"
                              >
                                Visualizza
                              </a>
                            </>
                          }
                        >
                          <DeleteIcon
                            style={{
                              cursor: "pointer",
                              opacity: 0.4,
                            }}
                            color="error"
                          />
                        </Tooltip>
                      ) : (
                        <DeleteIcon
                          style={{
                            cursor: "pointer",
                            opacity: 1,
                          }}
                          color="error"
                          onClick={(e) => {
                            e.stopPropagation();
                            let temp = [...risposte];
                            temp.splice(index, 1);

                            setRisposte(temp);
                          }}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <br />
          <Button
            variant="contained"
            onClick={(e) => {
              let temp = [...risposte];
              temp.push({});
              setRisposte(temp);
            }}
          >
            Aggiungi Risposta
          </Button>
          <br />
          <br />
        </Grid>

        <Grid item sm={12} xs={12}>
          <div className="flexSpaceBetween">
            <Button
              className="buttonIndietro"
              href={process.env.PUBLIC_URL + "/domande"}
              variant="contained"
            >
              Indietro
            </Button>
            <Button className="buttonSalva" type="submit" variant="contained">
              Salva
            </Button>
          </div>
        </Grid>
      </Grid>
    </form>
  );
};

export default Comp;
